import { useState } from 'react';
import { useParams } from 'react-router';
import { CapabilityDetailLayout, WORKING_COPY_ID } from '@/components/capability-detail/CapabilityDetailLayout';
import { CapabilityPlaceholder } from '@/components/capability-detail/CapabilityPlaceholder';

/** Capability type `application` — standard shell (overview, files, revisions, settings) and placeholder main tab. */
export default function ApplicationTypeDetailPage() {
    const { name } = useParams();
    const [selectedRevisionId, setSelectedRevisionId] = useState(WORKING_COPY_ID);

    return (
        <CapabilityDetailLayout
            typeLabel="Application"
            selectedRevisionId={selectedRevisionId}
            onRevisionChange={setSelectedRevisionId}
        >
            <CapabilityPlaceholder
                typeLabel="Application"
                capabilityName={name ?? ''}
                description="Defaults, exposure rules, and dependencies for this application are edited in settings and revision files. A structured editor will be added here."
            />
        </CapabilityDetailLayout>
    );
}
